exports.match = function (stringToMatch, lookup, fallbackValue) {
    if (lookup[stringToMatch]) {
        return lookup[stringToMatch]();
    }
    return fallbackValue;
};
